module.exports = __webpack_public_path__ + "img/TRHBTR2A.bb66c4b7.png";